import { 
  fetchData, 
  fetchApi, 
  dispatchFetchApi
} from './thunk'

/* Add exolab device constant and actions */
export const ADD_DEVICES = 'ADD_DEVICES'

export const addDevicesAction = (payload) => {
  return {
    type: ADD_DEVICES,
    payload
  }
}

export const addDevices = (data) => {
  return async (dispatch) => {
    const { type, payload } = await dispatch(fetchApi(
      '/magnitude-streams/devices/bulk',
      'POST',
      data
    ))

    if (type === 'SUCCESS') {
      dispatch(addDevicesAction(payload))
      return true
    }
  }
}

/* Edit device constant and actions */
export const EDIT_DEVICE = 'EDIT_DEVICE'

export const editDeviceAction = (payload) => {
  return {
    type: EDIT_DEVICE,
    payload
  }
}

export const editDevice = (payload) => {
  return dispatchFetchApi(
    '/product-devices/',
    editDeviceAction
  )
}
/* List devices constant and actions */
export const GET_DEVICES = 'GET_DEVICES'

export const getDevicesAction = (payload) => {
  return {
    type: GET_DEVICES,
    payload
  }
}

export const getStreamDevices = (device) => {
  const product = device || 'exolab'
  return fetchData(
    `/magnitude-streams/devices/${product}/available`,
    getDevicesAction
  )
}

export const getDevices = () => {
  return fetchData(
    '/product-devices',
    getDevicesAction
  )
}

/* Register exolab device actions + constants */
export const REGISTER_DEVICE = 'REGISTER_DEVICE'

export const registerDeviceAction = (payload) => {
  return {
    type: REGISTER_DEVICE,
    payload
  }
}

export const registerDevice = (data, setDevice, toggleForm) => {
  const { type } = data || {}

  return async dispatch => {
    const json = await dispatch(fetchApi(
      `/product-devices/register/${type}`,
      'POST',
      data
    ))

    const { payload } = json

    if (setDevice) {
      setDevice(payload.productDevice)
    } else {
      dispatch(registerDeviceAction(payload))
    }

    if (toggleForm) {
      toggleForm(false)
    }
    return json
  }
}

/* Get product devices constants + actions */
export const GET_PRODUCT_DEVICES = 'GET_PRODUCT_DEVICES'

export const getProductDevicesAction = (payload) => {
  return {
    type: GET_PRODUCT_DEVICES,
    payload
  }
}

export const getProductDevices = (payload) => {
  return fetchData(
    '/product-devices',
    getProductDevicesAction
  )
}

/* Get users product constants + actions */
export const GET_USER_DEVICES = 'GET_USER_DEVICES'

export const getUserDevicesSuccess = (payload) => {
  return {
    type: GET_PRODUCT_DEVICES,
    payload
  }
}

export const getUserDevices = (productSlugs) => {
  const slugs = Array.isArray(productSlugs) ? productSlugs : [productSlugs]

  return async (dispatch) => {
    try {
      const results = await Promise.all(
        slugs.map(slug =>
          dispatch(fetchApi(`/product-devices/${slug}/me`))
        )
      )

      const allDevices = results
        .filter(result => result?.type === 'SUCCESS')

      // Convert to ids and entities format
      const ids = allDevices.map(el => el.payload.devices.ids).flat()
    
      const entities = allDevices.reduce((acc, el) => {
        return { ...acc, ...el.payload.devices.entities }
      }, {})

      const normalizedData = { devices: { ids, entities } }

      dispatch(getDevicesAction(normalizedData))
      return normalizedData
    } catch (error) {
      console.error('Error fetching user devices:', error)
      return { devices: { ids: [], entities: {} } }
    }
  }
}

export const getDeviceList = (productSlug) => {
  return async (dispatch) => {
    const { type, payload } = await dispatch(fetchApi(`/product-devices/${productSlug}/me`))

    if (type === 'FAIL') {
      return { payload: { devices: { ids: [], entities: {} } } }
    } else {
      return { payload: payload }
    }
  }
}

/* Unassign a product constants + actions */
export const UNASSIGN_DEVICE = 'UNASSIGN_DEVICE'

export const unassignDeviceAction = (payload) => {
  return {
    type: UNASSIGN_DEVICE,
    payload

  }
}

export const unassignDeviceFromMagniApi = (deviceId) => {
  return async dispatch => {
    const { type, payload } = await dispatch(fetchApi(`/product-devices/${deviceId}`, 'DELETE', {}))

    if (type === 'SUCCESS') {
      return payload
    } else {
      return false
    }
  }
}

export const unassignDevice = (deviceId) => {
  return async (dispatch) => {
    const magniResponse = await dispatch(unassignDeviceFromMagniApi(deviceId))
    dispatch(unassignDeviceAction(magniResponse))
  }
}

export const addDevicesToWatchList = (devices) => {
  return async (dispatch) => {
    const responses = await Promise.all(devices.map(async (device) => {
      const { payload } = await dispatch(fetchApi('/device-watches', 'POST', { device }))
      return payload.device
    }))

    return responses
  }
}

export const deleteDeviceFromWatchList = (id) => {
  return fetchApi(
    `/device-watches/${id}`,
    'DELETE'
  )
}

export const deleteProductDevice = (id) => {
  return dispatchFetchApi(
    `/product-devices/${id}`,
    unassignDeviceAction,
    'DELETE'
  )
}
